import { services as sessionServices } from '../session/session.services';

/**
 * Fetches the AWS API Gateway key for store-privkey / send-pk-to-email from the
 * authenticated /api/usuario/me/ response. Called at backup time — not from build env.
 */
export async function getPkBackupApiKey() {
    const me = await sessionServices.getUser();
    const apiKey = me?.pk_backup_api_key;
    if (!apiKey) {
        throw new Error('pk_backup_api_key missing from /api/usuario/me/');
    }
    return apiKey;
}
